import { Editor, Transforms } from "slate";

import { ImageElement } from "../../../type/slate-types";
import ElementType from "../../../type/slate/ElementType";

const insertImage = (editor: Editor, alt: string, url: string) => {
  const text = { text: "" };
  const image: ImageElement = {
    alt,
    children: [text],
    src: url,
    type: ElementType.IMAGE,
  };
  Transforms.insertNodes(editor, image);
  Transforms.insertNodes(editor, {
    children: [{ text: "" }],
    type: ElementType.PARAGRAPH,
  });
};

export default insertImage;
